// Built-in import

import * as React from "react"

import { Button, Divider, Stack, Typography } from "@mui/material"

import DescriptionCard from "./description"
import { IServerProperty } from "@/store/slices/property"
import { Link } from "react-router-dom"
import ModalContent from "./ModalContent"
import PriceCard from "./price"
import ProgressShared from "@/components/pages/dashboard/single-property/invest-receiver/content/show-property/details/sidebar/investment/progress-shared"
import ProjectProfit from "./profit"
import PublicIcon from "@mui/icons-material/Public"
import TimeCard from "./time"
import TitleCard from "./title"
import copy from "copy-to-clipboard"
import { useGlobalContext } from "@/context/global-context"
import { useTranslation } from "react-i18next"
import Symbol from "../symobl"
import PeriodMonths from "../../PeriodMonths"
import InvestorsCount from "../../investorsCount"
import ShortDescription from "../../short-description"

// External import









// Internal import


interface IDetailsCard {
  item: IServerProperty
}

const DetailsCard: React.FC<IDetailsCard> = ({ item }) => {
  // Getting props as item
  const { t } = useTranslation()
  const { excerpt } = item
  let projectSymbol = item?.symbol || item?.symbol_fa || ""
  const { showModal, closeModal } = useGlobalContext()
  const openFaraboorsHandler = () => {
    if (!item) return
    copy(projectSymbol)
    showModal(<ModalContent property={item} onClose={closeModal} />, {
      width: ["100%", , 500],
    })
  }


  return (
    <Stack sx={{ py: 3, px: 2 }} spacing={2}>
      {/* title and tag */}
      <TitleCard item={item} />
      {/* description */}
      <DescriptionCard description={item?.owner_name || " - "} status={item?.status} />
      <Stack spacing={2} sx={{ marginTop: "0px !important" }}>
        {/* time & date */}
        {/* <TimeCard item={item} /> */}
        <Stack
          sx={{ marginTop: "5px !important" }}
          alignItems={"start"} direction="row" justifyContent="space-between">
          <Stack>
            <Button
              onClick={openFaraboorsHandler}
              disableRipple
              sx={{ p: 0, "&:hover": { bgcolor: "transparent" } }}
              variant="text"
              startIcon={<PublicIcon sx={{ fontSize: 20 }} />}
            >
              <Typography sx={{ color: "#E29314" }} variant="extraSmallRegular">
                {t("common:show_tarh_sejam")}
              </Typography>
            </Button>
          </Stack>
          <Stack>
            <Symbol item={item} />
          </Stack>
        </Stack>

        {/* price */}

        <Stack spacing={1} sx={{ marginTop: "5px !important" }}>
          <PriceCard price={item.max_investment_quantity} />
          <ProjectProfit item={item} />
        </Stack>
        <PeriodMonths value={item.period_months_description} />
        <ShortDescription value={item.financial_institution} title={t("common:financial_institution")} />
        <ShortDescription value={item.warranty_type} />
        {/* progress capital */}
        {/* <ProgressInvestment item={item} /> */}
        <Divider />

        <ProgressShared item={item} />
        {/* investment users */}
        {/* <InvestmentUsers item={item} /> */}
        <InvestorsCount value={item.investors_count} />
      </Stack>
      <Stack sx={{ m: 2 }} justifyContent="center" direction="row">
        {/* <Link to={`show/${item.id}`} target="_blank"> */}
        <Link to={`show/${item.id}`}>
          <Button
            variant="outlined"
            size="large"
            sx={{
              cursor: "pointer",
              maxWidth: "400px"
            }}
          >
            {t("common:see_property")}
          </Button>
        </Link>
      </Stack>
    </Stack>
  )
}

export default DetailsCard
